import React from 'react';

export function cropText(text, length) {
  return text && text.length > length ? (
    <span>{text.substr(0, length - 1)}…</span>
  ) : (
    text
  );
}
